import { Button, Col, Form, FormInstance, Row, Tag, notification } from 'antd';
import { DownloadOutlined, MinusOutlined } from '@ant-design/icons';
import React, { useContext, useState } from 'react';

import { AuthContext } from 'components/Auth/Auth';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import ConversionModal from '../Modals/ConversionModal';
import DualPieChart from 'components/theme_components/PieChart';
import ExportXLS from 'components/theme_components/ExportXLS';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ModalSFS from 'components/theme_components/ModalSFS';
import PaymentModal from '../Modals/PaymentModal';
import ProgressBarChart from 'components/theme_components/ProgressBarChart';
import Title from 'components/Title';
import { Typography } from 'antd';
import { format } from 'date-fns';
import FinancialScheduleModal from 'components/FinancialScheduleModal';
import ScheduleButton from 'components/ScheduleButton';
import { isNil } from 'lodash';
import ButtonOperation from 'components/ButtonOperation';
import TaskSButtonSFS from 'pages/workflow/workflowSFS/TasksButtonSFS';

const { Title: AntTitle } = Typography;
export type FinanceDetailsProps = {
  data: any;
  form: FormInstance;
  loading: boolean;
  ctrid: number;
};

const FinanceDetails = (props: FinanceDetailsProps) => {
  const { isInspect } = useContext(AuthContext);
  const { loading } = props;

  const [modalVisibleConfirm, setmodalVisibleConfirmVisible] = useState(false);
  const formatCurrency = (
    amount: number | string,
    currencyCode: string
  ): string => {
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;


    // Return '--' if amount is invalid
    if (isNaN(numAmount) || numAmount === null || numAmount === undefined) {
      return '--';
    }

    try {
      // Use browser's built-in Intl API for proper currency formatting
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(numAmount);
    } catch (error) {
      // Fallback if currency code is invalid
      return `${numAmount.toLocaleString('fr-FR')} ${currencyCode}`;
    }
  };

  const contractData = props.data;
  const financeData = props?.data?.assets[0] || {};
  const currency = contractData?.currcode || financeData?.currcode || 'EUR';

  const conelem = contractData?.conElements[0]?.conElemPrefinSteps || [];
  const conelemschedules = contractData?.conElements[0]?.conElemSchedules || [];

  const initial = financeData.initialAmount
    ? parseInt(financeData.initialAmount)
    : 0;
  const current = financeData.finamount ? parseInt(financeData.finamount) : 0;

  const getColor = (): string => {
    return financeData.assetnetamount > financeData.assetfinamount * 0.5
      ? '#d34444'
      : 'green';
  };

  const franchiseEnddate = conelemschedules.find(
    (schedule: any) => schedule.ctstype === 'PART'
  )
    ? conelemschedules.find((schedule: any) => schedule.ctstype === 'PART')
      .ctsenddate
    : '--';

  const percentage =
    contractData?.ctfinancedamount && conelem[0]?.ctesoutstandingamount
      ? Math.max(
        0,
        Math.min(
          100,
          ((+contractData.ctfinancedamount -
            +conelem[0].ctesoutstandingamount) /
            +contractData.ctfinancedamount) *
          100
        )
      ) || 0
      : 0;

  const startDate = contractData?.ctactivationdate
    ? new Date(contractData.ctactivationdate)
    : null;

  const productDuration = contractData?.offer?.durationmax || 0; // Duration in days

  const theoreticalEndDate = startDate
    ? new Date(startDate.setDate(startDate.getDate() + productDuration -1))
    : null;

  const exportData = [
    {
      ctactivationdate: contractData?.ctactivationdate || '--',
      theoreticalEndDate: theoreticalEndDate
        ? theoreticalEndDate.toISOString().split('T')[0]
        : '--',
      ctenddate: contractData?.ctenddate || '--',
      ctrequestdate: contractData?.ctrequestdate || '--',
      registrationdate: financeData?.registrationdate || '--',
      conversionDate: financeData?.conversionDate || '--',
      ctbic: contractData?.ctbic || '--',
      ctbankname: contractData?.ctbankname || '--',
      ctesstartdate: conelem[0]?.ctesstartdate || '--',
      // Update these two lines:
      ctfinancedamount: formatCurrency(
        contractData?.ctfinancedamount,
        currency
      ),
      ctesoutstandingamount: formatCurrency(
        conelem[0]?.ctesoutstandingamount,
        currency
      ),
    },
  ];

  const columns = [
    'ctactivationdate',
    'theoreticalEndDate',
    'ctenddate',
    'ctrequestdate',
    'registrationdate',
    'conversionDate',
    'ctbic',
    'ctbankname',
    'ctesstartdate',
    'ctfinancedamount',
    'ctesoutstandingamount',
  ];
  return (
    <Row
      style={{
        marginTop: '0.7rem',
        width: '100%',
        backgroundColor: 'white',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      }}
      color="white"
      className="pl-8 pr-8 pb-8 pt-8"
    >
      <Row align="middle" style={{ width: '100%' }}>
        <Col span={8}>
          <AntTitle className="mb-2 color-blue" level={3}>
            Financement
          </AntTitle>
        </Col>

        <Col span={16} className="d-flex justify-end p-0">
          <Col className="d-flex align-center">
            {/* <ExportXLS
              data={exportData}
              columns={columns}
              filename="financing-summary"
            />
 */}

            <Row style={{ fontWeight: 'bold', fontSize: 12 }}>
              <Col style={{ textAlign: 'left' }}>
                <Form.Item shouldUpdate noStyle>
                  {({ getFieldValue }) => {
                    console.log('selectedElementz', getFieldValue('selectedElement'))

                    return (
                      <FinancialScheduleModal
                        currcode={props?.data?.currcode}
                        finElement={getFieldValue(['elements', 'FIN'])?.find(
                          (ele: any) =>
                            ele.cteid === getFieldValue('selectedElement')
                        )}
                        loading={loading}
                        phase="PROD"
                        comcode="finSchedule"
                        controller={
                          <ScheduleButton
                            type="default"
                            className="no-border-radius ut-reset-btn mr-2 color-blue"
                            size="large"
                            comcode="finSchedule"
                            twoToneColor={
                              isNil(getFieldValue('offerid')) ? 'gray' : 'rgba(36, 55, 132, 1)'
                            }
                          ></ScheduleButton>
                        }
                      />
                    )
                  }}
                </Form.Item>
              </Col>
            </Row>
          </Col>


          {/* <PaymentModal
              mode="update"
              source="contract-detail"
              data={financeData}
              setVisible={(visible: boolean) => {
                setmodalVisibleConfirmVisible(visible);
              }}
              setmodalVisibleConfirmVisible={() =>
                setmodalVisibleConfirmVisible(true)
              }
            /> */}

          <TaskSButtonSFS
            clientName=""
            entityId={props?.ctrid}
            entityReference=""
            entityName="FINCONTRAT"
            currcode=""
            funcode="evSfsSchedulepayment"
            // refetch={() => refetch()}
            width={550}
            title="evSfsSchedulepayment"
            refetch={() => {
              // refetch()
            }}
            dataInput={contractData}
          >
             <Button type="primary" className="no-border-radius ut-reset-btn">
              <GetLabel label="programpayement" />
            </Button>
          </TaskSButtonSFS>
        </Col>
      </Row>
      <Row gutter={10} style={{ width: '100%' }} className="mt-8">
        <Col span={24}>
          <Row gutter={10}>
            <Col span={8} className="mb-4">
              <p className="font-size-13 gray-color">
                <GetLabel label="Début contrat" />
              </p>
              <p className="font-size-18">
                {contractData?.ctactivationdate || '--'}
              </p>
            </Col>
            <Col span={8} className="mb-4">
              <p className="font-size-13 gray-color">
                <GetLabel label="Fin franchise" />
              </p>
              <p className="font-size-18">{franchiseEnddate}</p>
            </Col>
            <Col span={8} className="mb-4">
              <p className="font-size-13 gray-color">
                <GetLabel label="Fin théorique" />
              </p>
              <p className="font-size-18">
                {' '}
                {theoreticalEndDate
                  ? format(theoreticalEndDate, 'yyyy-MM-dd')
                  : '--'}
              </p>
            </Col>
            <Col span={8}>
              <p className="font-size-13 gray-color">
                <GetLabel label="Réserve le:" />
              </p>
              <p className="font-size-18">
                {contractData?.ctrequestdate || '--'}
              </p>
            </Col>
            <Col span={8}>
              <p className="font-size-13 gray-color">
                <GetLabel label="Immatriculé le:" />
              </p>
              <p className="font-size-18">
                {financeData?.registrationdate || '--'}
              </p>
            </Col>
            <Col span={8}>
              <p className="font-size-13 gray-color">
                <GetLabel label="Converti le:" />
              </p>
              <p className="font-size-18">
                {financeData.conversionDate || '--'}
              </p>
            </Col>

          </Row>
          <Row gutter={10} className="mt-5">
            <Col span={8}>
              <p className="font-size-13 gray-color">
                <GetLabel label="ctDeliveryDate" />
              </p>
              <p className="font-size-18">
                {contractData?.ctDeliveryDate || '--'}
              </p>
            </Col>

            <Col span={8}>
              <p className="font-size-13 gray-color">
                <GetLabel label="firstregistrationdate" />
              </p>
              <p className="font-size-18">
                {financeData?.firstregistrationdate || '--'}
              </p>
            </Col>

            <Col span={8}>
              <p className="font-size-13 gray-color">
                <GetLabel label="Compte utilisé pour le paiement:" />
              </p>
              <p className="font-size-18">
                {contractData?.ctbic} - {contractData?.ctbankname}
              </p>
            </Col>
          </Row>
          <Row gutter={10} className="mt-9">
            <Col span={17}>
              <Row>
                <Col span={24}>
                  <p className="font-size-15 gray-color">
                    <GetLabel label="Périodes des taux" />
                  </p>
                </Col>
                <Col span={24} className="d-flex align-items-center">
                  <Row align="middle">
                    {conelem[0]?.ctesstartdate ? (
                      <>
                        <Tag className="tag-icon-nbr">1</Tag>
                        <p className="font-size-18">
                          {conelem[0]?.ctesstartdate}{' '}
                          <MinusOutlined className="gray-color-4 mr-2 ml-2" />
                        </p>
                      </>
                    ) : (
                      <p className="font-size-18 gray-color">No Data</p>
                    )}
                    {conelem[1]?.ctesstartdate ? (
                      <>
                        <Tag className="tag-icon-nbr">2</Tag>
                        <p className="font-size-18">
                          {conelem[1]?.ctesstartdate}{' '}
                          <MinusOutlined className="gray-color-4 mr-2 ml-2" />
                        </p>
                      </>
                    ) : null}
                    {conelem[2]?.ctesstartdate ? (
                      <>
                        <Tag className="tag-icon-nbr">3</Tag>
                        <span className="font-size-18">
                          {conelem[2]?.ctesstartdate}
                        </span>
                      </>
                    ) : null}
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col span={12} className="mt-6">
                  <p className="font-size-15 gray-color">
                    <GetLabel label="Montant initial" />
                  </p>
                  <p className="font-size-25">
                    {formatCurrency(contractData?.ctfinancedamount, currency)}
                  </p>
                </Col>
                <Col span={12} className="mt-6">
                  <p className="font-size-16 gray-color">
                    <GetLabel label="Solde restant à payer" />
                  </p>
                  <p
                    className="font-size-25"
                    style={{
                      color: getColor(),
                    }}
                  >
                    {formatCurrency(
                      contractData?.outstandingAmount,
                      currency
                    )}
                  </p>
                </Col>
              </Row>
            </Col>
            <Col span={7} className="d-flex justify-center align-center">
              {/* <DualPieChart
                percentageValue={parseInt(percentage.toString())}
                width={200}
                height={200}
                darkColor={getColor()}
                lightColor="#E8E8E8"
                label={`déja payé sur ${financeData.assetfinamount}€`}
              /> */}
              <ProgressBarChart
                percentageValue={parseInt(percentage.toString())}
                multicolor
                label={`déja payé sur ${formatCurrency(
                  financeData.assetfinamount,
                  currency
                )}`}
              />
            </Col>
          </Row>
          <Row gutter={10} className="mt-9">
            <Col span={24}>
              {/* <p className="font-size-17 gray-color">
                <GetLabel label="Lorem ipsum" />
              </p> */}
              <p className="font-size-15">{financeData.descriptionFin}</p>
            </Col>
          </Row>
        </Col>
      </Row>
      <ConfirmModal
        className="modalConfirmOrCancel"
        visible={modalVisibleConfirm}
        status="progress"
        message="Demande envoyée !"
        description="Votre demande est en cours de traitement.Vous serez notifié après décision."
        onConfirm={() => {
          !isInspect && setmodalVisibleConfirmVisible(false);
        }}
        onSeeMore={() => { }}
        Confirmcomcode="close"
        SeeMorecomcode="seemyrequest"
        onlyConfirm
        onlySeeMore
      />
    </Row>
  );
};

export default FinanceDetails;
